<div class="overlay" *ngIf="show">
  <div class="box">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="44"
    ></mat-progress-spinner>
    <div class="text">{{ text }}</div>
  </div>
</div>
